import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Textarea from 'components/Textarea'
import Button from 'components/Button'
import { requestSupersedSite } from 'api/site'
import { SiteSupersedeModalFooter, SiteSupersedeModalFooterButtonWrapper, SiteSupersedeTitle } from './style'


const SiteSupersedeModal = ({ site, toggleModal, getSite }) => {
  const [siteNames, setSiteNames] = useState('')

  const handleChange = (e) => {
    setSiteNames(e.target.value)
  }

  const closeModal = () => {
    toggleModal({})
  }

  const supersedSite = () => {
    requestSupersedSite(site.id, siteNames).then((data) => {
      toggleModal({})
      getSite()
    })
  }

  return (
    <>
      <SiteSupersedeTitle>{site.name}</SiteSupersedeTitle>
      <Textarea value={siteNames} onChange={handleChange} placeholder="supersedeModalPlaceholder" height="128px" />
      <SiteSupersedeModalFooter>
        <Button marginTop="0" type="secondary" onClick={closeModal}>
          <FormattedMessage id="cancel" />
        </Button>
        <SiteSupersedeModalFooterButtonWrapper>
          <Button
            onClick={supersedSite}
            marginTop="0"
            isDisabled={!siteNames}
            type={siteNames ? 'primary' : 'disabledPrimary'}
          >
            <FormattedMessage id="supersede" />
          </Button>
        </SiteSupersedeModalFooterButtonWrapper>
      </SiteSupersedeModalFooter>
    </>
  )
}

SiteSupersedeModal.propTypes = {
  site: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    name: PropTypes.string,
  }).isRequired,
  toggleModal: PropTypes.func.isRequired,
  getSite: PropTypes.func.isRequired,
}

export default SiteSupersedeModal
